import { isObject } from '@fanadise/common-utils';

export const isSortParam = (param: any) =>
  isObject(param) && param.prop && typeof param.prop === 'string';
